// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  background-color: #525659;
  font-family: Segoe UI, Tahoma, sans-serif;
}

.PDF {
  height: 548px;
  padding: 10px;
  width: calc(710px * 2);
}

.PDF .stf__block {
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/pdf.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["body {\n  margin: 0;\n  background-color: #525659;\n  font-family: Segoe UI, Tahoma, sans-serif;\n}\n\n.PDF {\n  height: 548px;\n  padding: 10px;\n  width: calc(710px * 2);\n}\n\n.PDF .stf__block {\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
